import { Component, OnInit } from '@angular/core';
import { AuthenticationService, Logger } from '@app/core';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { environment } from '@env/environment';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { PaymentsService } from '@app/finance/payments/payments.service';
import { PaymentsFormService } from '@app/finance/payments/payments-form.service';
import { Payment } from '@app/finance/payments/payment.model';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { MediaLibraryAcceptTypes } from '@app/shared/components/media-library/media-library-accept-types.enum';
import { DataSet } from '@app/shared/kendo/data-set';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoiceType } from '@app/finance/invoices/invoice-type.enum';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';
import { UserRole } from '@app/settings/users/roles/user-role.model';

const log = new Logger('PaymentsListComponent');

@Component({
  selector: 'app-payments-list',
  templateUrl: './payments-list.component.html',
  styleUrls: ['./payments-list.component.scss'],
})
export class PaymentsListComponent extends KendoGridComponent implements OnInit {
  paymentsResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;
  LaravelModels = LaravelModelsEnum;
  MediaLibraryAcceptTypes = MediaLibraryAcceptTypes;
  InvoiceType = InvoiceType;

  UserRoleType = UserRoleType;

  constructor(
    private paymentsService: PaymentsService,
    private paymentsFormService: PaymentsFormService,
    protected kendoGridService: KendoGridService,
    private route: ActivatedRoute,
    private router: Router,
    public accessService: AccessService,
    private auth: AuthenticationService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.state = CustomKendoFilter.getStateFromStorage('PaymentsListComponent');

      if (params.get('paymentable_id')) {
        this.state = new DataSet().addFilter('paymentable_id', Number(params.get('paymentable_id')));
      }

      if (params.get('id')) {
        this.state = new DataSet().addFilter('id', Number(params.get('id')));
      }

      this.loadData(this.state);
    });
  }

  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery
      .setDataSetFilters(state)
      .addIncludes(
        'bank_account',
        'company',
        'payment_method',
        'type',
        'clientable',
        'currency',
        'fee_currency',
        'refundable',
        'paymentable'
      );

    // проверява дали юзъра има определени роли, но не админ
    if (!this.accessService.hasAccess([], [])) {
      this.auth.accessToken.profile.roles.forEach((role: UserRole) => {
        if (role.id === UserRoleType.RESERVATION_AGENT || role.id === UserRoleType.CONTRACTING_AGENT) {
          this.apiQuery.addFilter('user_id', this.auth.accessToken.profile.id);
        }
      });
    }

    this.paymentsService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.paymentsResponse = response;
      this.data = response.getGridData();
    });

    CustomKendoFilter.pushStateInStorage('PaymentsListComponent', this.state);
  }

  edit(payment: Payment): void {
    this.paymentsFormService.open(payment).then(
      (res) => {
        this.loadData(this.state);
      },
      (res) => {
        log.info('modal closed');
      }
    );
  }

  delete(payment: Payment): void {
    this.paymentsService.destroy(payment.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  add() {
    this.paymentsFormService.open().then(
      (response) => {
        this.loadData(this.state);
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  clearFilters() {
    this.router.navigate(['/payments']);
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
